import { useTranslation } from "react-i18next";
import LeafCircleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafCircleLoader/LeafCircleLoader";
import { IconBookmarkFilled } from "../../../../common/icons/IconBookmark/IconBookmarkFilled";
import { IconBookmark } from "../../../../common/icons/IconBookmark/IconBookmark";
import defaultContent from "../../../../content/watchlist";
import "./WatchlistToggle.scss";

export const WatchlistToggle = ({
  watchlist,
  watchlistToggle,
  isLoading = false,
}: {
  watchlist: boolean;
  watchlistToggle: () => void | Promise<void>;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation(["watchlist"]);

  if (isLoading) {
    return <LeafCircleLoader isLoading width="2.25rem" height="2.25rem" />;
  }

  const label = (
    watchlist
      ? t("toggleButton.removeLabel", defaultContent.toggleButton.removeLabel)
      : t("toggleButton.addLabel", defaultContent.toggleButton.addLabel)
  ) as string;

  return (
    <button
      className="WatchListToggle"
      onClick={watchlistToggle}
      type="button"
      aria-label={label}
      aria-pressed={watchlist}
      data-testid="watchlist-toggle-btn"
    >
      {watchlist ? <IconBookmarkFilled /> : <IconBookmark />}
    </button>
  );
};
